export type Snack = {
    message: string;
    html?: string;
    color: string;
    show: boolean;
};

const snack = ref<Snack>({
    message: '',
    color: '',
    show: false,
});

const ERROR_BLACKLIST = ['The play() request was interrupted by a call to pause()', 'The operation was aborted'];

function isBlacklistedError(message: string) {
    return ERROR_BLACKLIST.some((err) => message.includes(err));
}

export default function () {
    const snackbarSuccess = (message: string, html?: string) => {
        snack.value = {
            message,
            html,
            color: 'success',
            show: true,
        };
    };
    const snackbarError = (message: string, html?: string) => {
        if (isBlacklistedError(message)) return;
        snack.value = {
            message,
            html,
            color: 'error',
            show: true,
        };
    };

    return {
        snackbarSuccess,
        snackbarError,
        snack,
    };
}
